import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'public/environments/environment';
import { MessagesFilterModel } from '../models/messages/MessagesFilterModel';
import { CommentsFilterModel } from '../models/messages/CommentsFilterModel';
@Injectable({ providedIn: 'root' })
export class MessagesService {
  refreshDetails = new BehaviorSubject<boolean>(false);
  refreshListDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  GetMessages(filterModel: MessagesFilterModel) {
    return this.http.post(`${environment.apiUrl}/messages/Messages`, filterModel);
  }
  GetGroups(compose:any) {
    return this.http.post(`${environment.apiUrl}/messages/GetGroups`, { CreateMessage: compose });
  }
  GetUsers() {
    // return this.http.get(`${environment.apiUrl}/messages/GetUsersInSameGroupAndEntity`);
    return this.http.get(`${environment.apiUrl}/messages/IndividualMessageUsers`);
  }
  PinMessage(messageId:any) {
    return this.http.get(`${environment.apiUrl}/messages/PinMessage/` + messageId);
  }

  NotifyMessage(obj:any) {
    return this.http.post(`${environment.apiUrl}/messages/NotifyMessageUser/`, obj);
  }

  GetGroupUsers(groupId:any) {
    return this.http.post(`${environment.apiUrl}/messages/GetUsers/`, { groupId });
  }
  GetGroupCollections(groupId:any, toReceivers: boolean) {
    const data = { GroupId: groupId, ToReceivers: toReceivers };
    return this.http.post(`${environment.apiUrl}/messages/GetCollections`, data);
  }
  GetCollectionsAndIndividual(groupId:any, toReceivers: boolean): any {
    const data = { GroupId: groupId, ToReceivers: toReceivers };
    return this.http.post(`${environment.apiUrl}/messages/GetCollectionsAndIndividual`, data);
  }
  CreateMessage(message:any, files: any, dicomFiles: any, slidesList:any, messageId:any, PDFToSign:any) {
    let createApiUrl = '/messages/CreateMessage';
    if (messageId !== -1 && messageId !== undefined) { // send draft message service
      createApiUrl = '/messages/EditMessage';
    }

    const formData = new FormData();
    files.forEach((file:any) => {
      if (file.attachmentId === undefined) {
        formData.append('file[]', file, file.name);
      }
    });
    // dicomFiles.forEach(file => {
    //     if (file.attachmentId === undefined) {
    //         formData.append('Dicom[]', file, file.name);
    //     }
    // });
    // slidesList.forEach((slide, index) => {
    //   slide.files.forEach(file => {
    //       if (file.attachmentId === undefined) {
    //           formData.append('Slide-' + index, file, file.name);
    //       }
    //   });
    //   delete slide.files;
    //   delete slide.selectedEntity;
    // });
    // message.slideList = slidesList;
    PDFToSign.forEach((item:any) => {
      formData.append('Signature-' + item.attachmentId, item.file, item.file.name);
    });
    let copyPDFToSign = JSON.parse(JSON.stringify(PDFToSign));
    copyPDFToSign.map((item:any) => delete item.file);
    message.signatureList = copyPDFToSign;
    formData.append('data', JSON.stringify(message));
    return this.http.post(`${environment.apiUrl}` + createApiUrl, formData);
  }
  DeleteMessage(messageId:any) {
    return this.http.get(`${environment.apiUrl}/messages/DeleteMessage/` + messageId);
  }
  ShareMessage(data:any) {
    return this.http.post(`${environment.apiUrl}/messages/ShareMessage`, data);
  }
  GetComments(filterModel: CommentsFilterModel) {
    return this.http.post(`${environment.apiUrl}/comments/GetComments/`, filterModel);
  }
  AddComment(commentobj:any) {
    return this.http.post(`${environment.apiUrl}/comments/AddComment`, commentobj);
  }
  EditComment(commentobj:any) {
    return this.http.post(`${environment.apiUrl}/comments/EditComment`, commentobj);
  }
  EditReply(commentobj:any) {
    commentobj.ObjectType = 'MessageEntity';
    return this.http.post(`${environment.apiUrl}/comments/EditReply`, commentobj);
  }
  GetCollections(messageId:any) {
    return this.http.post(`${environment.apiUrl}/messages/GetCollections`, { messageId });
  }
  GetReplies(GetReplyObj:any) {
    GetReplyObj.ObjectType = 'MessageEntity';
    return this.http.post(`${environment.apiUrl}/comments/GetReplies`, GetReplyObj);
  }
  AddReply(commentobj:any) {
    commentobj.ObjectType = 'MessageEntity';
    return this.http.post(`${environment.apiUrl}/comments/AddReply`, commentobj);
  }
  GetUnseenMessagesCount() {
    return this.http.get(`${environment.apiUrl}/messages/GetUnseenMessagesCount`);
  }
  GetUsersToDelegate(messageId:any) {
    return this.http.get(`${environment.apiUrl}/messages/GetUsersToDelegate/` + messageId);
  }
  DelegateCommentAssignee(userCollectionGroupinMessageId:any) {
    return this.http.get(`${environment.apiUrl}/messages/DelegateCommentAssignee/` + userCollectionGroupinMessageId);
  }
  CommentOnMessageAsWho(messageId:any) {
    return this.http.get(`${environment.apiUrl}/messages/CommentOnMessageAsWho/` + messageId);
  }
  GetEntitySelectedSlides(entityId: number, CommunicationMethodLookup: number) {
    return this.http.get(`${environment.apiUrl}/messages/GetEntitySelectedSlides?entityId=${entityId}&CommunicationMethodLookup=${CommunicationMethodLookup}`);
  }
  GetMessagesGroupEntityUsers(data:any) {
    return this.http.post(`${environment.apiUrl}/messages/GetMessagesGroupEntityUsers`, data);
  }
}
